import { Toggle } from '@platform/components';
import { useState } from 'react';
import { AuthedPage, HeaderFooterLayout } from '../../app';
import { OrganizationCards } from './OrganizationCards';
import { ProjectCards } from './ProjectCards';

type OrganizationSearchToggleProps = {
  onChange: (value: string | number | undefined) => void;
};
const OrganizationSearchToggle = ({ onChange }: OrganizationSearchToggleProps) => {
  const [toggleValue, setToggleValue] = useState<string>('projects');
  return (
    <div className='w-fit'>
      <Toggle
        size='sm'
        onChange={(isSelected) => {
          onChange(isSelected ? 'organizations' : 'projects');
          setToggleValue(isSelected ? 'organizations' : 'projects');
        }}
        description={`Toggle to show ${toggleValue === 'projects' ? 'organizations' : 'projects'}`}
      >
        Show Organizations
      </Toggle>
    </div>
  );
};

const ProjectSearch = () => {
  const [toggleValue, setToggleValue] = useState<string>('projects');
  const handleToggleChange = (value: string | number | undefined) => {
    setToggleValue(value as string);
  };

  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='flex flex-col gap-4 p-6'>
          <div className='text-4xl font-semibold text-gray-900 pb-4'>
            Search for an existing project, or co-create your own project with an organization.
          </div>
          <OrganizationSearchToggle onChange={handleToggleChange} />
          {toggleValue === 'projects' && <ProjectCards />}
          {toggleValue === 'organizations' && <OrganizationCards />}
        </div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default ProjectSearch;
